<template>
  <div
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="main">
      <div class="breadcrumb">
        <span
          class="crumb"
          @click="
            $router.push({ path: '/' });
            resetSetItem('isActive', 0);
          "
          >首页</span
        >
        <span>></span>
        <span class="crumb" @click="$router.push({ path: '/radio' })"
          >音频</span
        >
        <span>></span>
        <span style="color:#0091ff">{{ title }}</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="box">
            <div class="box-top">
              <div class="top-info">
                <div class="img">
                  <img :src="articleDetail.cover_url" alt />
                </div>
                <div class="message">
                  <p>{{ articleDetail.name }}</p>
                  <div class="other-info">
                    <!--                    <div @click="audition">-->
                    <!--                      播放：-->
                    <!--                      <span>{{articleDetail.is_play}}次</span>-->
                    <!--                    </div>-->
                    <div>
                      最新更新：
                      <span>{{ articleDetail.publish_at | timefilters }}</span>
                    </div>
                  </div>
                  <el-button @click="audition">
                    <img src="@/assets/img/watch.png" alt />
                    <span>播放</span>
                  </el-button>
                  <el-button
                    @click="memberBtn"
                    v-if="!articleDetail.is_jurisdiction"
                    style="margin-left: 100px;"
                    >听完整版</el-button
                  >
                </div>
              </div>
              <div class="introd">{{ articleDetail.summary }}</div>
            </div>
            <div class="box-bottom">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="节目" name="first">
                  <ul class="program">
                    <li
                      v-for="(item, i) in hotList"
                      :key="i"
                      @click="hotDetail(item)"
                    >
                      <div class="img">
                        <img :src="item.cover_url" alt />
                      </div>
                      <div class="hot-box">
                        <p>{{ item.title }}</p>
                        <div class="cont">{{ item.summary }}</div>
                        <div class="num">
                          <div>
                            <img src="@/assets/img/play1.png" alt />
                            <span>{{ item.visit_times }}</span>
                          </div>
                          <div>
                            <img src="@/assets/img/clock.png" alt />
                            <span>{{
                              item.audio_duration | timeToString
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-tab-pane>
                <el-tab-pane label="评价" name="second">
                  <ul class="evaluate">
                    <li v-for="(item, i) in evaluateList" :key="i">
                      <div class="img">
                        <img :src="item.user.avatar" alt />
                      </div>
                      <div class="cont">
                        <p class="name">{{ item.nickname }}</p>
                        <p class="time">
                          {{ item.display_time | timefilters }}
                        </p>
                        <div>{{ item.content }}</div>
                      </div>
                      <div class="like">
                        <span>{{ item.like_times }}</span>
                        <img
                          src="@/assets/img/like1.png"
                          alt
                          v-if="item.is_like == false"
                          @click="commentBtn(item.id, i)"
                        />
                        <img
                          src="@/assets/img/like2.png"
                          alt
                          v-else
                          @click="commentBtn(item.id, i)"
                        />
                      </div>
                    </li>
                  </ul>
                  <div class="morePage" v-if="show_page">
                    <div @click="moreData">
                      <p>加载更多</p>
                      <div>
                        <img src="@/assets/img/more.png" alt />
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <LoginDialog
      :loginDialogs="loginDialogs"
      @child-event="getParentEvent"
    ></LoginDialog>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getCommentLike } from "@/api/public";
import { getAudioSeriesList, getAudioCommentsList } from "@/api/radio";
import LoginDialog from "@/components/loginDialog";
import { getTdkList} from "@/api/tdk";

export default {
  name: "radio_detail",
  components: {
    Wechart,
    LoginDialog
  },
  data() {
    return {
      member_btn: 1,
      loginDialogs: false,
      page: 1,
      per: 5,
      audio_type: "",
      play_count: 1,
      show_page: true,
      id: "",
      title: "",
      activeName: "first",
      articleDetail: {},
      hotList: [],
      evaluateList: [],
      loading: true
    };
  },
  methods: {
    // 会员弹框
    memberBtn() {
      this.$emit("getIsPlaying", this.play_count++);
      this.$emit("getMemberBtn", this.member_btn++);
    },
    // 弹框
    getParentEvent(data) {
      this.loginDialogs = data;
    },
    commentBtn(id, i) {
      if (
        localStorage.getItem("Authorization") == "" ||
        localStorage.getItem("Authorization") == null
      ) {
        this.loginDialogs = true;
      } else {
        if (this.evaluateList[i].is_like) {
          this.evaluateList[i].like_times--;
        } else {
          this.evaluateList[i].like_times++;
        }
        this.evaluateList[i].is_like = !this.evaluateList[i].is_like;
        getCommentLike(id);
      }
    },
    moreData() {
      this.getCommentsList();
    },
    getCommentsList() {
      var params = {
        id: this.id,
        page: this.page,
        per: this.per,
        type: "AudioArticle"
      };

      getAudioCommentsList(params).then(res => {
        this.evaluateList = this.evaluateList.concat(res.data.data);

        if (this.page >= res.data.meta.total_pages) {
          this.show_page = false;
        } else {
          this.page++;
        }
      });
    },
    audition() {
      this.$emit("getIsPlaying", this.play_count++);
    },
    handleClick(tab, event) {},
    hotDetail(scope) {
      this.$router.push({
        name: "hot_detail",
        params: { id: scope.id, PId: this.id, pTitle: this.title }
      });
    }
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
    this.title = this.$route.params.title;
    this.id = this.$route.params.id;
    var params = {
      id: this.id,
      equipment: "android"
    };
    getAudioSeriesList(params).then(res => {
      this.title = res.data.data[0].name;
      this.articleDetail = res.data.data[0];
      this.hotList = res.data.data[0].articles;
      this.audio_type = res.data.data[0].audio_type;
      this.loading = false;
      this.$ba([
        ["ptype", "list"],
        ["acategory", "radiolist"],
        ["acname", "音频栏目"],
        ["atype", "radio"],
        ["acategory2", "radio" + this.id],
        ["ac2name", this.title]
      ]);
      // const { } = res.data.data[0]
      this.getCommentsList();
    });
  },
  mounted() {
    this.$emit("getATId", this.id);
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  .crumb {
    cursor: pointer;
  }
}

.box {
  background: #ffffff;
  padding: 30px;
  margin-bottom: 60px;

  .box-top {
    .top-info {
      display: flex;

      .img {
        width: 24%;
        margin-right: 30px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .message {
        width: 80%;
        position: relative;

        p {
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .other-info {
          display: flex;
          color: #999999;
          font-size: 14px;

          div {
            margin-right: 20px;

            span {
              color: #333333;
            }
          }
        }

        .el-button {
          position: absolute;
          bottom: 6%;
          background: #0091ff;
          color: #ffffff;
          font-size: 14px;
          border-radius: 18px;
          padding: 8px 20px;
          border: none;
        }
      }
    }

    .introd {
      font-size: 14px;
      color: #999999;
      line-height: 22px;
      margin-top: 20px;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 25px;
    }
  }

  .box-bottom {
    margin-top: 16px;

    > .el-tabs__nav-wrap::after {
      height: 0;
    }

    > .el-tabs__item {
      font-size: 16px;
      font-weight: 600;
    }

    > .el-tabs__active-bar {
      height: 4px;
    }

    > .el-tabs__nav {
      padding-bottom: 6px;
    }

    .program {
      li {
        margin-bottom: 30px;
        display: flex;
        cursor: pointer;

        .img {
          margin-right: 30px;
          width: 18%;
          height: 140px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .hot-box {
          position: relative;
          width: 80%;

          p {
            font-size: 20px;
            margin-top: 5px;
          }

          .cont {
            font-size: 14px;
            line-height: 20px;
            color: #999999;
            margin-top: 14px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }

          .num {
            display: flex;
            font-size: 14px;
            line-height: 20px;
            color: #999999;
            position: absolute;
            bottom: 4%;
            width: 100%;

            div {
              margin-right: 10%;

              span {
                margin-left: 10px;
              }
            }

            div:last-child {
              span {
                margin-left: 14px;
              }
            }
          }
        }
      }

      li:last-child {
        margin-bottom: 0px;
      }
    }

    .evaluate {
      li {
        display: flex;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 60px;
        margin-top: 30px;
        position: relative;

        .img {
          width: 7%;
          height: 7%;
          margin-right: 20px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }

        .cont {
          width: 80%;
          font-size: 16px;

          .name {
            line-height: 36px;
            font-weight: 500;
          }

          .time {
            font-size: 14px;
            color: #999999;
          }

          div {
            line-height: 30px;
            margin-top: 10px;
          }
        }

        .like {
          width: 10%;
          position: absolute;
          bottom: 30px;
          right: 0;
          text-align: right;

          span {
            margin-right: 6px;
            color: #999999;
            font-size: 14px;
          }
        }
      }

      li:first-child {
        margin-top: 0;
      }
      li:last-child {
        padding-bottom: 30px;
        border-bottom: none;

        .like {
          bottom: 0;
        }
      }
    }
  }
}
>>> .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 30px;
}
>>> .el-tabs__nav-wrap::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/radio/detail.vue